import { render, staticRenderFns } from "./questionEdit.vue?vue&type=template&id=f2a16500&scoped=true&"
import script from "./questionEdit.vue?vue&type=script&lang=js&"
export * from "./questionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a16500",
  null
  
)

export default component.exports